import React from 'react';
import ContentArea from "../components/content-area/Content";
import ComingSoonPage from "../components/homepage/ComingSoonPage";
import SelfiesIconPng from "../assets/icons/selfies.png";

const Selfies = () => (
  <ContentArea title="Selfies" icon={SelfiesIconPng} container={false}>
    <ComingSoonPage />
  </ContentArea>
);

export default Selfies;
